// src/composables/loadingState.js
import { ref } from 'vue';

export const isLoading = ref(false); // وضعیت اصلی لودینگ: True/False

let activeRequests = 0; // شمارنده درخواست‌های همزمان

export const incrementRequests = () => {
  activeRequests++;
  if (activeRequests > 0) { // اگر حتی یک درخواست فعال هست، لودینگ رو نشون بده
    isLoading.value = true;
  }
};

export const  decrementRequests = () => {
  activeRequests--;
  if (activeRequests <= 0) { // وقتی هیچ درخواست فعالی نمونده، لودینگ رو مخفی کن
    isLoading.value = false;
    activeRequests = 0; // اطمینان از اینکه شمارنده منفی نشود
  }
};
